import AxiosPrivate from "./axios/axiosPrivate";

export const fetchBranchOrders = async (branch_id) => {
  return await AxiosPrivate.get(
    `/orders/restaurant-orders/${branch_id}`,
    {}
  );
};

export const addCategory = async (branch_id) => {
  return await AxiosPrivate.post(`/restaurant/add-category/${branch_id}`, {});
};

export const getFoodCategories = async (branch_id) => {
  return await AxiosPrivate.get(`/restaurant/all-categories/${branch_id}`, {});
};

export const editOrder = async (
  food_name,
  price,
  description,
  food_image,
  food_content,
  tax,
  discount_rate,
  menu_id,
  restaurant_code
) => {
  return await AxiosPrivate.post(
    `/branch-orders/${restaurant_code}`,
    {
      food_name,
      price,
      description,
      food_image,
      food_content,
      tax,
      discount_rate,
      menu_id,
    },
  );
};

export const changeOrderStatus = async (payload) => {
  return await AxiosPrivate.post(`/orders/orders-tracking-api/`, payload);
};

export const getTopDishes = async (branch_id) => {
  return await AxiosPrivate.get(`/restaurant/top-dishes/${branch_id}/`)
}

//functions for editing order
export const addToCart = async (data) => {
  return AxiosPrivate.post("orders/cart/", data);
}

export const getCartItems = async (orderId) => {
  return await AxiosPrivate.get(`orders/cart/${orderId}`)
}
export const placeOrder = async (payload, orderId) => {
  return AxiosPrivate.post(`orders/dashboard-order-checkout/${orderId}`, payload);
}

export const increamentOrder = async (payload, orderId) => {
  return AxiosPrivate.post(`orders/increment-order-cart-item/${orderId}`, payload);
}

export const deleteOrderItems = async (payload, orderId) => {
  return AxiosPrivate.post(`orders/dashboard-delete-food-items-from-order/${orderId}`, payload);
};

export const deleteEditCartItems = async (orderId) => {
  return AxiosPrivate.post(`orders/dashboard-delete-items-on-order/${orderId}`);
}

//functions for creating from dashboard
export const dashboardAddToCart = async (payload, user_id) => {
  return AxiosPrivate.post(`orders/cart/${user_id}`, payload);
}

export const getDashboardCartItems = async (user_id) => {
  return await AxiosPrivate.get(`orders/cart/${user_id}`)
}

export const dashboardCheckout = async (payload, user_id) => {
  return AxiosPrivate.post(`orders/new-dashboard-order-checkout/${user_id}`, payload)
}

export const deleteDashboardCartItems = async (orderId) => {
  return AxiosPrivate.delete(`orders/dashboard-delete-items-on-menu/${orderId}/`);
}

